import React from "react";
import { Card, Descriptions, Typography } from "antd";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{ orderSummary: Record<string, unknown> }} props
 */
export default function OperationRequestOrderBriefCard({ orderSummary }) {
  return (
    <Card className={styles.sidebarCard} size="small" title="תקציר הזמנה">
      <Descriptions column={1} size="small" colon={false}>
        <Descriptions.Item label="מספר הזמנה">
          <Text strong dir="ltr">
            {orderSummary.displayNumber || "—"}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="שם לקוח">
          {orderSummary.contacts?.primaryName || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="יעד / מלון">{orderSummary.destination || "—"}</Descriptions.Item>
        <Descriptions.Item label="תאריכים">
          {(orderSummary.checkIn || "—") + " – " + (orderSummary.checkOut || "—")}
        </Descriptions.Item>
        <Descriptions.Item label="סטטוס">{orderSummary.status || "—"}</Descriptions.Item>
        <Descriptions.Item label="תאריך יצירה">{orderSummary.createdAtLabel || "—"}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
